












































import { Component, Vue } from 'vue-property-decorator';
import {
  List, Empty, Search,
} from 'vant';
import axios from '@/common/axios-utils';

@Component({
  components: {
    [List.name]: List,
    [Empty.name]: Empty,
    [Search.name]: Search,
  },
})
export default class InvestmentPage extends Vue {
  searchData: any = {
    phone: '',
    pageNum: 1,
    pageSize: 20,
  }

  total: number = 0

  loading: boolean = false

  finished: boolean = false

  error: boolean = false

  phoneList: Array<any> = []

  onSearch() {
    this.searchData.pageNum = 1;
    this.phoneList = [];
    this.finished = false;
    this.error = false;
    this.onLoadPhoneList();
  }

  async onLoadPhoneList() {
    const isSuccess = await this.getPhoneList();
    if (isSuccess) {
      if (this.phoneList.length >= this.total) {
        this.finished = true;
      } else {
        this.searchData.pageNum += 1;
      }
    } else {
      this.error = true;
    }
    this.loading = false;
  }

  async getPhoneList() {
    this.loading = true;
    const url = '/apigw/query/displaynumber/list';
    const params = {
      ...this.searchData,
    };
    const { error, data }: ApiResponse.MDPData = await axios.post(url, params);
    if (!error && data) {
      const { list, total } = data;
      this.phoneList = this.phoneList.concat(list) || [];
      this.total = total;
      return true;
    } else {
      this.error = true;
      return false;
    }
  }
}
